/**
 * @license GPL-3.0-only
 *
 * @author Mark Mayes / mm-dev
 *
 *
 * @module PD/EL_IDS
 *
 * @description
 * ## IDs for some elements shared between CSS and JS
 */


export const APP_WRAPPER = 'pd-container';
export const ACTIVEAREA_CANVAS = 'activearea-canvas';

export const PIPE_WALL_CANVAS = 'pipewall-canvas';
